/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import CircleLoader from '@/components/loaders/CircleLoader'
import ItemsPagination from '../ItemsPagination'
import HeaderLayout from './components/HeaderLayout'
import { TableContainer } from '@chakra-ui/react'
import DefaultGrid from '../DefaultGrid'
import { useSearchParams } from 'react-router-dom'

const ItemsListWithToggleLayout = ({
  cards,
  currentPage,
  footer,
  header,
  itemsLayout = 'list',
  isLoading,
  table,
  onChangePage,
  onLayoutChange,
  showCounter = true,
  textNoItems,
  textSearchParamsNoItems,
  totalItems,
  totalPages

}) => {
  const [isCard, setIsCard] = useState(itemsLayout === 'cards')
  const [searchParams, setSearchParams] = useSearchParams()
  const currentOnLayoutChange = (layout) => {
    onLayoutChange && onLayoutChange(layout)

    setSearchParams({
      ...Object.fromEntries(searchParams),
      itemsLayout: layout
    })

    setIsCard(layout === 'cards')
  }

  if (isLoading) {
    return <CircleLoader isCentered={true} />
  }

  const hasTable = Boolean(table)
  const hasCards = Boolean(cards)

  return (
    <ItemsPagination
      currentPage={currentPage}
      footer={footer}
      header={
        <HeaderLayout
          content={header}
          hasCards={hasCards}
          hasTable={hasTable}
          isCard={isCard}
          onLayoutChange={currentOnLayoutChange}
        />
      }
      onChangePage={onChangePage}
      searchParamsSize={searchParams.size}
      showCounter={showCounter}
      textNoItems={textNoItems}
      textSearchParamsNoItems={textSearchParamsNoItems}
      totalItems={totalItems}
      totalPages={totalPages}
    >
    { isCard
      ? <>
          { hasCards &&
            <DefaultGrid>
              { cards }
            </DefaultGrid>
          }
        </>
      : <>
          { hasTable &&
            <TableContainer className="mb-6">
              { table }
            </TableContainer>
          }
        </>
    }
    </ItemsPagination>
  )
}

export default ItemsListWithToggleLayout
